import { CustomerDocumentPostRequestBody, CustomerDocumentPostResponse } from '@lio/api-types';
import { customerQueryKey } from '@services/customer/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useCreateCustomerDocument = (customerId: string) => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (body: CustomerDocumentPostRequestBody) =>
      client.post(`customer/${customerId}/document`, { json: body }).json<CustomerDocumentPostResponse>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: customerQueryKey._customerDocument(customerId) });
      queryClient.invalidateQueries({ queryKey: ['customer', customerId, 'document-archive'] });
    },
  });
  return { ...result, createCustomerDocumentAsync: result.mutateAsync };
};
